import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Icon from '../components/AppIcon';

const ProtectedRoute = ({ children, requireAdvisor = false, requireAdmin = false }) => {
  const { isAuthenticated, isAdvisor, isAdmin, loading, profileLoading } = useAuth();

  // Wait for BOTH auth and profile to load
  if (loading || profileLoading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-center">
          <Icon name="Loader2" size={48} className="animate-spin text-primary mx-auto mb-4" />
          <p className="text-muted-foreground">Verificando autenticación...</p>
        </div>
      </div>
    );
  }

  // Not authenticated - redirect to signin
  if (!isAuthenticated) {
    return <Navigate to="/signin" replace />;
  }

  // Admin check - only admins can access admin-only routes
  if (requireAdmin && !isAdmin) {
    return <Navigate to="/signin" replace />;
  }

  // Advisor check - both advisors and admins can access advisor routes
  if (requireAdvisor && !isAdvisor && !isAdmin) {
    return <Navigate to="/signin" replace />;
  }

  return children;
};

export default ProtectedRoute;